export default import.meta.ROLLDOWN_FILE_URL_479VhuutRPKqW_6Ht6iXzA